import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Timer } from '../interfaces/timer.interface';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class PushService {
  private fcmUrl = 'https://fcm.googleapis.com/fcm/send';

  constructor(private http: HttpClient) {
  }

  sendPushNotification(timer: Timer): void {
    const payload = {
      notification: {
        title: `${timer.name}`,
        body: `O timer ${timer.name} foi iniciado`,
      },
      to: localStorage.getItem('PUSH_NOTIFICATION_TOKEN')
    };

    const headers = {
      Authorization: `key=${environment.firebaseConfig.apiKey}`,
      'Content-Type': 'application/json',
    };

    this.http.post(this.fcmUrl, payload, { headers }).subscribe(
      (response) => {
        console.log('Notificação enviada com sucesso:', response);
      },
      (error) => {
        console.error('Erro ao enviar notificação:', error);
      }
    );
  }
}
